import { useState } from "react";
import { useDispatch } from "react-redux";

import { deleteStudentList } from "../../studentSlice";

import { Button } from "../../../../components/Button";

const DeleteStudentButton = ({ students, setSelectedStudents }) => {
  const dispatch = useDispatch();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleDeleteClick = () => {
    setIsDeleteModalOpen(true);
  };

  // [추가] 실제 삭제 로직
  const confirmDelete = () => {
    dispatch(
      deleteStudentList({
        studentIds: students.map((student) => student.id),
      })
    );
    setSelectedStudents([]);
    setIsDeleteModalOpen(false);
  };

  // [추가] 삭제 모달 닫기
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const styles = {
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      color: "#000",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "8px",
      width: "300px",
      maxWidth: "90%",
    },
    modalHeader: {
      textAlign: "center",
      fontSize: "16px",
      marginBottom: "40px",
    },
    modalBody: {
      marginBottom: "40px",
      lineHeight: "1.0",
    },
    modalFooter: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    dangerButton: {
      backgroundColor: "#FF4444",
      color: "#fff",
      border: "none",
      padding: "6px 12px",
      width: "100%",
      cursor: "pointer",
      borderRadius: "4px",
    },
    cancelButton: {
      backgroundColor: "#EBEBEB",
      color: "#737373",
      border: "none",
      padding: "6px 12px",
      cursor: "pointer",
      width: "100%",
      borderRadius: "4px",
    },
  };

  return (
    <div>
      <Button
        backgroundColor="#FFFFFF"
        color="#FF4444"
        border="1px solid #EBEBEB"
        fontSize="16px"
        padding="10px 35px"
        onClick={() => handleDeleteClick()}
      >
        삭제하기
      </Button>

      {isDeleteModalOpen && (
        <div style={styles.modalOverlay} onClick={closeDeleteModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>학생 삭제</div>
            <div style={styles.modalBody}>
              <strong style={{ textAlign: "center" }}>
                정말 {students[0].name} 외 {students.length - 1}명의 학생 정보를
              </strong>
              <p>
                <strong style={{ textAlign: "center" }}>
                  삭제하시겠습니까?
                </strong>
              </p>
            </div>
            <div style={styles.modalFooter}>
              <button style={styles.dangerButton} onClick={confirmDelete}>
                네
              </button>
              <button style={styles.cancelButton} onClick={closeDeleteModal}>
                아니오
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteStudentButton;
